
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"23","viewBox":"0 0 25 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.125 4.688a.52.52 0 01.52-.521h6.25a.52.52 0 110 1.041h-6.25a.52.52 0 01-.52-.52zM3.125 14.063a.52.52 0 01.52-.521h6.25a.52.52 0 010 1.041h-6.25a.52.52 0 01-.52-.52zM3.125 9.375a.52.52 0 01.52-.52h3.126a.52.52 0 110 1.04H3.646a.52.52 0 01-.521-.52z","fill":"#343440"}}),_c('path',{attrs:{"d":"M2 1h21a1 1 0 011 1v14.75a1 1 0 01-1 1h-3.208v1H23a2 2 0 002-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v14.75a2 2 0 002 2h11.542v-1H2a1 1 0 01-1-1V2a1 1 0 011-1z","fill":"#343440"}}),_c('path',{attrs:{"d":"M13.542 15.093v6.436c0 .893 1.081 1.338 1.71.704l1.24-1.251a.243.243 0 01.349 0l1.24 1.251c.63.634 1.71.19 1.71-.704v-6.436a.989.989 0 01-.605-.092l-.394-.196v6.724l-1.24-1.251a1.243 1.243 0 00-1.77 0l-1.24 1.251v-6.724l-.395.196a.989.989 0 01-.605.092z","fill":"#343440"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.635 8.329L10.84 9.375l1.795 1.046a2 2 0 01.992 1.654l.075 2.03 2.075-1.03a2 2 0 011.78 0l2.074 1.03.075-2.03a2 2 0 01.992-1.653l1.795-1.047-1.795-1.046a2 2 0 01-.992-1.654l-.075-2.03-2.075 1.03a2 2 0 01-1.779 0l-2.075-1.03-.075 2.03a2 2 0 01-.992 1.654zm-2.299.182a1 1 0 000 1.728l1.796 1.046a1 1 0 01.496.827l.075 2.03a1 1 0 001.444.86l2.075-1.031a1 1 0 01.89 0L19.185 15a1 1 0 001.444-.858l.076-2.03a1 1 0 01.495-.828l1.796-1.046a1 1 0 000-1.728L21.2 7.465a1 1 0 01-.495-.827l-.076-2.03a1 1 0 00-1.444-.86L17.111 4.78a1 1 0 01-.89 0l-2.074-1.03a1 1 0 00-1.444.858l-.075 2.03a1 1 0 01-.496.828L10.336 8.51z","fill":"#343440"}})])
          )
        }
      }
    